import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useSEO from '../hooks/useSEO';
import AfiaChatScreen from '../components/AfiaChatScreen';
import { trackEvent } from '../utils/analytics';
import { WELCOME_SEEN_KEY } from '../constants/welcome';

// /afia — the page the "Ask Afia" QR code opens. Straight into the conversation: someone who
// scanned a poster wants to talk to Afia, not to find her on a website first.
export default function AfiaPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useSEO({
    title: 'Ask Afia — Mama Africa AI Heritage Guide',
    description: 'Chat with Afia, the Mama Africa AI guide: Ghanaian names and meanings, coming home from the diaspora, life in Ghana, culture and the Mama Africa store.',
  });

  useEffect(() => {
    trackEvent('afia_page_view', { src: params.get('src') || 'direct' });
    // Someone who came in through Afia has met the site; skip the welcome screen next time.
    try { sessionStorage.setItem(WELCOME_SEEN_KEY, '1'); } catch { /* private mode */ }
  }, [params]);

  return <AfiaChatScreen variant="page" onClose={() => navigate('/')} />;
}
